import React from 'react';
import { connect } from 'react-redux';

import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Collapse from '@material-ui/core/Collapse';
import AddIcon from '@material-ui/icons/Add';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import Theme from './Theme';
import apiActions from '../actions/apiActions';
import alertActions from '../actions/alertActions';
import loadingActions from '../actions/loadingActions';
import apiService from '../services/apiService';

class Service extends React.Component {
	state = {
		searchQuery: '',
		activeStep: 0,
		selectedService: null,
		selectedAction: null,
		searchResults: [],
		commenceBilling: true,
		installLineItems: [],
		cpeTower: '',
		cpeMakeModel: '',
		cpeMacAddress: '',
		cpeIpAddress: '',
		cpeEap: false,
	}

	constructor(props) {
		super(props);
		this.initialState = this.state;
	}

	handleChange = event => {
		this.setState({ [event.target.id]: event.target.value });
	}

	handleCheckboxChange = name => event => {
		this.setState({ [name]: event.target.checked });
	}

	handleRadioChange = name => event => {
		this.setState({ [name]: event.target.value });
	}

	prevStep = event => {
		const { activeStep } = this.state;
		this.setState({ activeStep: (activeStep > 0? activeStep - 1 : 0) });
	}

	reset = event => {
		this.setState(this.initialState);
	}

	addInstallLineItem = event => {
		let { installLineItems } = this.state;
		installLineItems.push({
			description: '',
			cost: ''
		});
		this.setState({
			installLineItems
		});
	}

	handleInstallLineItemChange = index => event => {
		let { installLineItems } = this.state;
		installLineItems[index][event.target.name] = event.target.value;
		this.setState({
			installLineItems
		});
	}

	deleteInstallLineItem = index => event => {
		let { installLineItems } = this.state;
		installLineItems.splice(index, 1);
		this.setState({
			installLineItems
		});
	}

	doSearch = event => {
		event.preventDefault();
		this.props.dispatch(apiActions.search(this.state.searchQuery));
	}

	selectService = serviceid => async event => {
		try {
			this.props.dispatch(loadingActions.start());
			let res = await apiService.request('GetClientsProducts', { serviceid });
			let res2 = await apiService.request('DCSICPE', { method: 'get', serviceid });
			this.setState({ service: res.products.product[0], cpes: res2.cpe, activeStep: 1 });
			this.props.dispatch(loadingActions.end());
		}
		catch (err) {
			this.props.dispatch(loadingActions.end());
			this.props.dispatch(alertActions.error(err.message));
		}
	}

	selectAction = action => async event => {
		if (['install', 'upgrade'].indexOf(action) !== -1) {
			try {
				this.props.dispatch(loadingActions.start());
				let res = await apiService.request('FoperatorGetTowers');
				this.setState({
					selectedAction: action,
					activeStep: 2,
					towers: res.towers
				});
				this.props.dispatch(loadingActions.end());
			}
			catch (err) {
				this.props.dispatch(loadingActions.end());
				this.props.dispatch(alertActions.error(err.message));
			}
		}
		else {
			this.setState({
				selectedAction: action,
				activeStep: 2
			});
		}
	}

	checkRadio = async event => {
		try {
			this.props.dispatch(loadingActions.start());
			let res = await apiService.request('DCSIAntenna', { serviceid: this.state.service.id });
			this.setState({
				assuranceRadio: res
			});
			this.props.dispatch(loadingActions.end());
		}
		catch (err) {
			this.props.dispatch(loadingActions.end());
			this.props.dispatch(alertActions.error(err.message));
		}
	}

	checkConnection = async event => {
		try {
			this.props.dispatch(loadingActions.start());
			let res = await apiService.request('DCSISession', { method: 'check', serviceid: this.state.service.id });
			this.setState({
				assuranceConnection: res
			});
			this.props.dispatch(loadingActions.end());
		}
		catch (err) {
			this.props.dispatch(loadingActions.end());
			this.props.dispatch(alertActions.error(err.message));
		}
	}

	assignNewIPs = async event => {
		try {
			this.props.dispatch(loadingActions.start());
			await apiService.request('DCSIAssignNewIPs', { serviceid: this.state.service.id });
			this.props.dispatch(loadingActions.end());
		}
		catch (err) {
			this.props.dispatch(loadingActions.end());
			this.props.dispatch(alertActions.error(err.message));
		}
	}

	submitInstall = async event => {
		event.preventDefault();
		try {
			this.props.dispatch(loadingActions.start());
			// add radio CPE
			await apiService.request('DCSICPE', {
				method: 'add',
				type: 'Antenna',
				serviceid: this.state.service.id,
				description: this.state.cpeMakeModel,
				mac: this.state.cpeMacAddress,
				ip: this.state.cpeIpAddress,
				eap: this.state.cpeEap,
				eap_ap_lock: this.state.cpeEap? '1' : '0',
			});
			// UpdateClientProduct to set tower
			await apiService.request('UpdateClientProduct', {
				serviceid: this.state.service.id,
				customfields: btoa('a:1:{s:5:"Tower";s:' + this.state.cpeTower.length + ':"' + this.state.cpeTower + '";}')
			});
			// add router CPE if autoprovisioning
			if (this.state.routerAutoprov) {
				await apiService.request('DCSICPE', {
					method: 'add',
					type: 'Router',
					serviceid: this.state.service.id,
					description: 'TP-Link VX230v',
					autoprov: '1',
					autoprov_type: 'tplink-vx230v',
					serial: this.state.routerSerial,
				});
			}
			// add billable item(s) for extras
			for (let lineItem of this.state.installLineItems) {
				await apiService.request('AddBillableItem', {
					clientid: this.state.service.clientid,
					description: 'Fixed Wireless Installation: ' + lineItem.description,
					amount: lineItem.cost,
					invoiceaction: 'nextinvoice'
				});
			}
			// if commencing billing, AcceptOrder
			if (this.state.commenceBilling) {
				await apiService.request('AcceptOrder', {
					orderid: this.state.service.orderid,
					sendemail: false
				});
			}

			this.props.dispatch(loadingActions.end());
			this.setState({ activeStep: 3 });

		}
		catch (err) {
			this.props.dispatch(loadingActions.end());
			this.props.dispatch(alertActions.error(err.message));
			return;
		}
	}

	submitUpgrade = async event => {
		event.preventDefault();
		try {
			this.props.dispatch(loadingActions.start());
			// update existing CPE of type Antenna (if any)
			let updateCpe = this.state.cpes.find(cpe => cpe.type === 'Antenna');
			if (updateCpe) {
				await apiService.request('DCSICPE', {
					method: 'edit',
					id: updateCpe.id,
					description: this.state.cpeMakeModel,
					mac: this.state.cpeMacAddress,
					ip: this.state.cpeIpAddress,
					eap: this.state.cpeEap,
					eap_ap_lock: this.state.cpeEap? '1' : '0',
				});
			}
			else {
				await apiService.request('DCSICPE', {
					method: 'create',
					type: 'Antenna',
					serviceid: this.state.service.id,
					description: this.state.cpeMakeModel,
					mac: this.state.cpeMacAddress,
					ip: this.state.cpeIpAddress,
					eap: this.state.cpeEap,
					eap_ap_lock: this.state.cpeEap? '1' : '0',
				});
			}
			// UpdateClientProduct to set tower
			await apiService.request('UpdateClientProduct', {
				serviceid: this.state.service.id,
				customfields: btoa('a:1:{s:5:"Tower";s:' + this.state.cpeTower.length + ':"' + this.state.cpeTower + '";}')
			});
			// add billable item(s) for extras
			for (let lineItem of this.state.installLineItems) {
				await apiService.request('AddBillableItem', {
					clientid: this.state.service.clientid,
					description: 'Fixed Wireless Upgrade: ' + lineItem.description,
					amount: lineItem.cost,
					invoiceaction: 'nextinvoice'
				});
			}

			this.props.dispatch(loadingActions.end());
			this.setState({ activeStep: 3 });

		}
		catch (err) {
			this.props.dispatch(loadingActions.end());
			this.props.dispatch(alertActions.error(err.message));
			return;
		}
	}

	render() {
		const { service } = this.props;
		return <Stepper activeStep={this.state.activeStep} orientation="vertical">
			<Step key="search">
				<StepLabel>Select a Service</StepLabel>
				<StepContent>
					<form onSubmit={this.doSearch} style={{marginBottom: Theme.spacing.unit * 2}}>
						<TextField autoFocus required maxLength="64" label="Search" id="searchQuery" fullWidth value={this.state.searchQuery} onChange={this.handleChange} helperText="Search by customer number, name, company name, or service address." style={{marginBottom: Theme.spacing.unit * 2}}></TextField>
						<Button type="submit" variant="raised" color="primary" disabled={service.searching}>Search</Button>
					</form>
					{service.results && service.results.length > 0 &&
						<div>
							<Typography variant="caption">{service.results.length} result{service.results.length > 1 && 's'}:</Typography>
							<List>
								{service.results.map((result, index) =>
									<ListItem key={index} button onClick={this.selectService(result.id)}>
										<ListItemText primary={result.servicetype + ' - ' + result.serviceaddress} secondary={'#' + result.clientid + ' ' + result.firstname + ' ' + result.lastname + ' (' + result.companyname + ')'} />
									</ListItem>
								)}
							</List>
						</div>
					}
				</StepContent>
			</Step>
			<Step key="action">
				<StepLabel>Select a Task</StepLabel>
				<StepContent>
					<List>
						<ListItem button onClick={this.selectAction('install')} disabled={this.state.service && this.state.service.status !== 'Pending'}>
							<ListItemText
								primary="Install"
								secondary="View service details, add CPE details, commence billing."
							/>
						</ListItem>
						<ListItem button onClick={this.selectAction('fixup')}>
							<ListItemText
								primary="Fixup"
								secondary="View service details, check radio connection quality."
							/>
						</ListItem>
						<ListItem button onClick={this.selectAction('upgrade')}>
							<ListItemText
								primary="Upgrade"
								secondary="Update service &amp; CPE details, charge upgrade fee."
							/>
						</ListItem>
					</List>
					<Button type="button" onClick={this.prevStep} style={{marginRight: Theme.spacing.unit}}>Back</Button>
				</StepContent>
			</Step>
			<Step key="details">
				<StepLabel>Details</StepLabel>
				<StepContent>
					{this.state.selectedAction === 'install' &&
						<form onSubmit={this.submitInstall}>
							<Typography variant="title">CPE Details</Typography>
							<div style={{marginBottom: Theme.spacing.unit * 2}}>
								<FormControl fullWidth>
									<InputLabel htmlFor="cpeTower">Tower</InputLabel>
									<Select
										native
										value={this.cpeTower}
										onChange={this.handleChange}
										inputProps={{
											id: 'cpeTower',
											margin: 'dense',
											required: true
										}}
									>
										<option value="" />
										{this.state.towers.map(tower => <option key={tower} value={tower}>{tower}</option>)}
									</Select>
								</FormControl>
								<TextField required margin="dense" label="Make/Model" id="cpeMakeModel" fullWidth value={this.state.cpeMakeModel} onChange={this.handleChange} />
								<TextField required margin="dense" label="MAC Address" id="cpeMacAddress" fullWidth value={this.state.cpeMacAddress} onChange={this.handleChange} />
								<Collapse in={!/^(?:NodeOne|Beam): /.test(this.state.cpeTower)}>
									<TextField required={!/^(?:NodeOne|Beam): /.test(this.state.cpeTower)} margin="dense" label="IP Address" id="cpeIpAddress" fullWidth value={this.state.cpeIpAddress} onChange={this.handleChange} />
								</Collapse>
								<Collapse in={/^NodeOne: /.test(this.state.cpeTower)}>
									<FormGroup>
										<FormControlLabel
											control={<Switch color="primary" checked={this.state.cpeEap} onChange={this.handleCheckboxChange('cpeEap')} />}
											label="WPA2-EAP authentication"
										/>
										<Collapse in={this.state.cpeEap}>
											<FormHelperText>EAP credentials will be generated when you save &ndash; go to Fixup for this service to view them.</FormHelperText>
										</Collapse>
									</FormGroup>
								</Collapse>
							</div>
							<Typography variant="title">Router Details</Typography>
							<div style={{marginBottom: Theme.spacing.unit * 2}}>
								<FormGroup>
									<FormControlLabel
										control={<Switch color="primary" checked={this.state.routerAutoprov} onChange={this.handleCheckboxChange('routerAutoprov')} />}
										label="Router auto-provisioning (TP-Link VX230v)"
									/>
									<Collapse in={this.state.routerAutoprov}>
										<TextField required={this.state.routerAutoprov} margin="dense" label="Serial" id="routerSerial" fullWidth value={this.state.routerSerial} onChange={this.handleChange} />
									</Collapse>
								</FormGroup>
								<Collapse in={!this.state.routerAutoprov}>
									<Typography variant="subheading" paragraph>
										<AccountCircleIcon />{this.state.service.customfields.customfield.find(customfield => customfield.name === 'PPPoE Username').value}
										<br />
										<VpnKeyIcon />{this.state.service.customfields.customfield.find(customfield => customfield.name === 'PPPoE Password').value}
									</Typography>
								</Collapse>
							</div>
							<Typography variant="title" paragraph>Service Plan</Typography>
							<Typography paragraph>{this.state.service.configoptions.configoption.find(configoption => configoption.option === 'Plan').value}</Typography>
							<Typography variant="title">Billing</Typography>
							<FormGroup>
								<FormControlLabel
									control={<Switch color="primary" checked={this.state.commenceBilling} onChange={this.handleCheckboxChange('commenceBilling')} />}
									label="Commence recurring billing"
								/>
							</FormGroup>
							<Typography paragraph>
								Add additional custom line items for non-recurring costs if required
								<Button variant="fab" mini color="primary" aria-label="add" onClick={this.addInstallLineItem} style={{marginLeft: Theme.spacing.unit}}>
									<AddIcon />
								</Button>
							</Typography>
							{this.state.installLineItems.map((lineItem, index) =>
								<Grid key={index} container spacing={Theme.spacing.unit} style={{marginBottom: Theme.spacing.unit * 2}}>
									<Grid item xs={5} sm={6} md={9}>
										<TextField label="Description" value={lineItem.description} name="description" onChange={this.handleInstallLineItemChange(index)} required fullWidth margin="dense" />
									</Grid>
									<Grid item xs={4} sm={4} md={2}>
										<TextField
											label="Cost"
											value={lineItem.cost}
											name="cost"
											onChange={this.handleInstallLineItemChange(index)}
											required
											fullWidth
											margin="dense"
										/>
									</Grid>
									<Grid item xs={3} sm={2} md={1}>
										<IconButton onClick={this.deleteInstallLineItem(index)}><DeleteIcon /></IconButton>
									</Grid>
								</Grid>
							)}
							<Button type="button" onClick={this.prevStep} style={{marginRight: Theme.spacing.unit}}>Back</Button>
							<Button type="submit" variant="raised" color="primary">Submit</Button>
						</form>
					}
					{this.state.selectedAction === 'fixup' &&
						<div>
							<Typography variant="title" paragraph>Service Assurance</Typography>
							<div style={{marginBottom: Theme.spacing.unit * 2}}>
								<Button type="button" onClick={this.checkRadio} variant="raised" color="primary" style={{marginRight: Theme.spacing.unit, marginBottom: Theme.spacing.unit}}>Check Radio</Button>
								<Button type="button" onClick={this.checkConnection} variant="raised" color="primary" style={{marginRight: Theme.spacing.unit, marginBottom: Theme.spacing.unit}}>Check Connection</Button>
								<Button type="button" onClick={this.assignNewIPs} variant="raised" color="primary" style={{marginRight: Theme.spacing.unit, marginBottom: Theme.spacing.unit}}>Assign New IPs</Button>
							</div>
							{(this.state.assuranceRadio || this.state.assuranceConnection) &&
								<div id="assuranceResults">
									<Typography variant="title" paragraph>Assurance Results</Typography>
									{this.state.assuranceRadio &&
										<div>
											<Typography paragraph>
												Receive Signal: {this.state.assuranceRadio.radio.rxPower}<br />
												Modulation: {this.state.assuranceRadio.radio.modulation}<br />
												LAN Port Status: {this.state.assuranceRadio.radio.lanStatus}
											</Typography>
											<Typography paragraph>
												Ping Received/Sent: {this.state.assuranceRadio.ping.received + ' / ' + this.state.assuranceRadio.ping.sent} ({Math.round(Number(this.state.assuranceRadio.ping.received) / Number(this.state.assuranceRadio.ping.sent) * 100)}%)<br />
												Min/Avg/Max RTT: {
													Number(this.state.assuranceRadio.ping.rtt.min) + '/' +
													Number(this.state.assuranceRadio.ping.rtt.avg) + '/' +
													Number(this.state.assuranceRadio.ping.rtt.max) + ' ms'
												}
											</Typography>
										</div>
									}
									{this.state.assuranceConnection &&
										<div>
											<Typography paragraph>
												{this.state.assuranceConnection.connected?
													<span><CheckCircleIcon /> Connected ({this.state.assuranceConnection.details})</span>
												:
													<span><HighlightOffIcon /> Not Connected</span>
												}
											</Typography>
										</div>
									}
								</div>
							}
							<Typography variant="title" paragraph>CPE Details</Typography>
							<Typography paragraph>
								Tower: {this.state.service.customfields.customfield.find(customfield => customfield.name === 'Tower').value}<br />
								Make/Model: {this.state.cpes.find(cpe => cpe.type === 'Antenna').description}<br />
								MAC Address: {this.state.cpes.find(cpe => cpe.type === 'Antenna').mac}<br />
								IP Address: {this.state.cpes.find(cpe => cpe.type === 'Antenna').ip}<br />
								EAP Username: {this.state.cpes.find(cpe => cpe.type === 'Antenna').eap_user}<br />
								EAP Password: {this.state.cpes.find(cpe => cpe.type === 'Antenna').eap_pass}
							</Typography>
							<Typography variant="title" paragraph>Router Details</Typography>
							<Typography variant="subheading" paragraph>
								<AccountCircleIcon />{this.state.service.customfields.customfield.find(customfield => customfield.name === 'PPPoE Username').value}
								<br />
								<VpnKeyIcon />{this.state.service.customfields.customfield.find(customfield => customfield.name === 'PPPoE Password').value}
							</Typography>
							<Typography variant="title" paragraph>Service Plan</Typography>
							<Typography paragraph>{this.state.service.configoptions.configoption.find(configoption => configoption.option === 'Plan').value}</Typography>
							<Button type="button" onClick={this.prevStep} style={{marginRight: Theme.spacing.unit}}>Back</Button>
							<Button type="button" variant="raised" color="primary" onClick={this.reset}>Start Over</Button>
						</div>
					}
					{this.state.selectedAction === 'upgrade' &&
						<form onSubmit={this.submitUpgrade}>
							<Typography variant="title">CPE Details</Typography>
							<div style={{marginBottom: Theme.spacing.unit * 2}}>
								<FormControl fullWidth>
									<InputLabel htmlFor="cpeTower">Tower</InputLabel>
									<Select
										native
										value={this.cpeTower}
										onChange={this.handleChange}
										inputProps={{
											id: 'cpeTower',
											margin: 'dense',
											required: true
										}}
									>
										<option value="" />
										{this.state.towers.map(tower => <option key={tower} value={tower}>{tower}</option>)}
									</Select>
								</FormControl>
								<TextField required margin="dense" label="Make/Model" id="cpeMakeModel" fullWidth value={this.state.cpeMakeModel} onChange={this.handleChange} />
								<TextField required margin="dense" label="MAC Address" id="cpeMacAddress" fullWidth value={this.state.cpeMacAddress} onChange={this.handleChange} />
								<Collapse in={!/^(?:NodeOne|Beam): /.test(this.state.cpeTower)}>
									<TextField required={!/^(?:NodeOne|Beam): /.test(this.state.cpeTower)} margin="dense" label="IP Address" id="cpeIpAddress" fullWidth value={this.state.cpeIpAddress} onChange={this.handleChange} />
								</Collapse>
								<Collapse in={/^NodeOne: /.test(this.state.cpeTower)}>
									<FormGroup>
										<FormControlLabel
											control={<Switch color="primary" checked={this.state.cpeEap} onChange={this.handleCheckboxChange('cpeEap')} />}
											label="WPA2-EAP authentication"
										/>
										<Collapse in={this.state.cpeEap}>
											<FormHelperText>EAP credentials will be generated when you save &ndash; go to Fixup for this service to view them.</FormHelperText>
										</Collapse>
									</FormGroup>
								</Collapse>
							</div>
							<Typography variant="title">Router Details</Typography>
							<div style={{marginBottom: Theme.spacing.unit * 2}}>
								<Typography variant="subheading" paragraph>
									<AccountCircleIcon />{this.state.service.customfields.customfield.find(customfield => customfield.name === 'PPPoE Username').value}
									<br />
									<VpnKeyIcon />{this.state.service.customfields.customfield.find(customfield => customfield.name === 'PPPoE Password').value}
								</Typography>
							</div>
							<Typography variant="title" paragraph>Service Plan</Typography>
							<Typography paragraph>{this.state.service.configoptions.configoption.find(configoption => configoption.option === 'Plan').value}</Typography>
							<Typography variant="title">Billing</Typography>
							<Typography paragraph>
								Add additional custom line items for non-recurring costs if required
								<Button variant="fab" mini color="primary" aria-label="add" onClick={this.addInstallLineItem} style={{marginLeft: Theme.spacing.unit}}>
									<AddIcon />
								</Button>
							</Typography>
							{this.state.installLineItems.map((lineItem, index) =>
								<Grid key={index} container spacing={Theme.spacing.unit} style={{marginBottom: Theme.spacing.unit * 2}}>
									<Grid item xs={5} sm={6} md={9}>
										<TextField label="Description" value={lineItem.description} name="description" onChange={this.handleInstallLineItemChange(index)} required fullWidth margin="dense" />
									</Grid>
									<Grid item xs={4} sm={4} md={2}>
										<TextField
											label="Cost"
											value={lineItem.cost}
											name="cost"
											onChange={this.handleInstallLineItemChange(index)}
											required
											fullWidth
											margin="dense"
										/>
									</Grid>
									<Grid item xs={3} sm={2} md={1}>
										<IconButton onClick={this.deleteInstallLineItem(index)}><DeleteIcon /></IconButton>
									</Grid>
								</Grid>
							)}
							<Button type="button" onClick={this.prevStep} style={{marginRight: Theme.spacing.unit}}>Back</Button>
							<Button type="submit" variant="raised" color="primary">Submit</Button>
						</form>
					}
				</StepContent>
			</Step>
			<Step key="complete">
				<StepLabel>Completed</StepLabel>
				<StepContent>
					<Typography variant="title" paragraph>Completed Successfully</Typography>
					<Button type="button" variant="raised" color="primary" onClick={this.reset}>Start Over</Button>
				</StepContent>
			</Step>
		</Stepper>;
	}
}

function mapStateToProps(state) {
	const { service } = state;
	return { service };
}

export default connect(mapStateToProps)(Service);


// WEBPACK FOOTER //
// ./src/components/Service.js